<template>
  <div>
    <label for="">{{ label }} {{ required ? '*' : '' }}</label>
    <v-select
        :items="items"
        :value="value"
        @input="$emit('input', $event)"
        :rules="[...isRequired, ...rules]"
        outlined
        required
        dense
        hide-details="auto"
        class="q-autocomplete"
        v-bind="$attrs"
        :item-text="itemText"
        :item-value="itemValue"
    />
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  },
  computed: {
    isRequired() {
      return this.required ? [(v) => !!v || `${this.label} is required`] : [];
    }
  }
};
</script>

